import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logoPureNav from './LogoNav.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-pure_navegacao shadow-lg sticky top-0 z-50 backdrop-blur-lg bg-opacity-95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          
          {/* Logo */}
          <img src={logoPureNav} className='grid grid-cols-3 place-items-center space-x-3 w-32'/>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link 
              to="/" 
              className="text-pure_titulo hover:text-pure_titulo transition-colors duration-300 font-medium font-montserrat">
              Início
            </Link>
            <Link 
              to="/candles" 
              className="text-pure_titulo hover:text-pure_titulo transition-colors duration-300 font-medium font-montserrat">
              Velas
            </Link>
            <Link 
              to="/wax-melts" 
              className="text-pure_titulo hover:text-pure_titulo transition-colors duration-300 font-medium font-montserrat">
              Wax Melts
            </Link>
            <a 
              href="https://instagram.com/pure.pt_" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-pure_titulo hover:text-pure_titulo transition-colors duration-300 font-medium font-montserrat">
              Instagram
            </a>
          </nav>

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2 rounded-md text-[#8B4513] hover:bg-[#F7F1F0] transition-colors duration-300"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-[#E6D7C3] animate-fade-in">
            <div className="flex flex-col space-y-4">
              <Link 
                to="/" 
                className="text-[#8B4513] hover:text-[#A0522D] transition-colors duration-300 font-medium"
                style={{ fontFamily: 'The Seasons, serif' }}
                onClick={() => setIsMenuOpen(false)}
              >
                Início
              </Link>
              <Link 
                to="/candles" 
                className="text-[#8B4513] hover:text-[#A0522D] transition-colors duration-300 font-medium"
                style={{ fontFamily: 'The Seasons, serif' }}
                onClick={() => setIsMenuOpen(false)}
              >
                Velas
              </Link>
              <Link 
                to="/wax-melts" 
                className="text-[#8B4513] hover:text-[#A0522D] transition-colors duration-300 font-medium"
                style={{ fontFamily: 'The Seasons, serif' }}
                onClick={() => setIsMenuOpen(false)}
              >
                Wax Melts
              </Link>
              <a 
                href="https://instagram.com/pure.pt_" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#8B4513] hover:text-[#A0522D] transition-colors duration-300 font-medium"
                style={{ fontFamily: 'The Seasons, serif' }}
                onClick={() => setIsMenuOpen(false)}
              >
                Instagram
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;